import { SubtractIcon } from 'assets/icons';
import classNames from 'classnames';
import { Button } from 'ui/redesign/Button';
import { ButtonVariant } from 'ui/redesign/Button/constants';
import { getDateWithTimezone } from 'utils/helpers';
import { ContractTableStatuses, GenerateContractsTableHeadingsProps } from './types';
import { ProfilePermissions } from 'reduxStore/reducers/ProfileSlice/types';
import {
  ContractStatusDto,
  ContractTypeDto,
  DocumentTableParticipantDto,
  RelatedDocumentDto,
} from 'services/EdmsService/types';

export const GenerateContractsTableHeadings = ({
  getContractById,
  subscribe,
  accept,
  permissions,
  organizationId,
}: GenerateContractsTableHeadingsProps): TableHeading[] => {
const isHasSignPermission = permissions?.includes(ProfilePermissions.Document_Sign);

  return [
    {
      attributeName: '',
      name: '',
      renderColumn: (column, rowData) => (
        <div className="flex justify-center whitespace-nowrap">
          <SubtractIcon
            className="cursor-pointer"
            onClick={() => getContractById(String(rowData.id))}
          />
        </div>
      ),
    },
    {
      attributeName: 'number',
      name: 'Номер договора',
      renderColumn: (column) => <span className="w-[100px] break-words">{column as string}</span>,
    },
    {
      attributeName: 'date',
      name: 'Дата договора',
      renderColumn: (column) => (
        <span className="whitespace-nowrap">
          {getDateWithTimezone(column as string, undefined, 'dd.MM.yyyy')}
        </span>
      ),
    },
    {
      attributeName: 'type',
      name: 'Тип',
      renderColumn: (column) => (
        <span className="w-[100px] break-words">{(column as ContractTypeDto).name || ''}</span>
      ),
    },
    {
      attributeName: 'status',
      name: 'Статус',
      renderColumn: (column) => {
        return (
          <span
            className={classNames(
              'block break-words rounded-[4px] px-2 py-[1px] text-center text-white sm:w-[85px] sm:text-xs lg:w-24 lg:text-sm',
              'bg-' + ContractTableStatuses[(column as ContractStatusDto).id].color
            )}
          >
            {(column as ContractStatusDto).name
              ? ContractTableStatuses[(column as ContractStatusDto).id].name
              : ContractTableStatuses[(column as ContractStatusDto).id].name}
          </span>
        );
      },
    },
    {
      attributeName: 'participants',
      name: 'Стороны',
      renderColumn: (column) => (
        <span className="w-[100px] break-words">
          {(column as DocumentTableParticipantDto[]).map((participant) => (
            <div key={participant.organizationId}>
              <span>
                {participant.organizationShortName},{' '}
                {participant.dateOfSigning
                  ? `подписан ${getDateWithTimezone(
                      String(participant.dateOfSigning),
                      undefined,
                      'dd.MM.yyyy'
                    )}`
                  : 'ожидает подписания'}
              </span>
              <br />
            </div>
          ))}
        </span>
      ),
    },
        ...(isHasSignPermission ? [{
      attributeName: 'isRequiredSigning',
      name: 'Действия',
      renderColumn: (column: TableDataColumn, rowData: TableData) => {
        const participantOrganization = (
          rowData.participants as DocumentTableParticipantDto[]
        ).find((item) => item.organizationId === organizationId);
        const isButtonDisabled =
          rowData.relatedDocument !== null &&
          (rowData.relatedDocument as RelatedDocumentDto)?.status.id === 1;
        const toolTipContent =
          (rowData.relatedDocument as RelatedDocumentDto) &&
          `Требуется подписание (принятие) '${
            (rowData.relatedDocument as RelatedDocumentDto)?.type.name
          }'`;
        if (
          (rowData.status as ContractStatusDto).id === 1 &&
          !participantOrganization?.dateOfSigning &&
          isHasSignPermission
        ) {
          return (column as boolean) ? (
            <Button
              variant={ButtonVariant.GHOST}
              className={classNames(
                'cursor-pointer whitespace-nowrap text-center text-primary-100',
                {
                  'cursor-not-allowed text-primary-40': isButtonDisabled,
                }
              )}
              onClick={() =>
                subscribe &&
                subscribe(
                  rowData.id as string,
                  rowData.number as string,
                  (rowData.type as ContractTypeDto).name ?? '',
                  rowData.date as string,
                  rowData.concurrencyStamp as string
                )
              }
              data-tooltip-id="action-tooltip"
              data-tooltip-content={toolTipContent}
              disabled={isButtonDisabled}
            >
              ПОДПИСАТЬ
            </Button>
          ) : (
            <Button
              disabled={isButtonDisabled}
              variant={ButtonVariant.GHOST}
              className={classNames(
                'cursor-pointer whitespace-nowrap text-center text-primary-100',
                {
                  'cursor-not-allowed text-primary-40': isButtonDisabled,
                }
              )}
              onClick={() =>
                accept &&
                accept(
                  rowData.id as string,
                  rowData.concurrencyStamp as string,
                  (rowData.type as ContractTypeDto).name ?? ''
                )
              }
              data-tooltip-id="action-tooltip"
              data-tooltip-content={toolTipContent}
            >
              ПРИНЯТЬ
            </Button>
          );
        } else {
          return <div className="whitespace-nowrap"></div>;
        }
      },
    }] : [])
  ];
};
